// extracted by mini-css-extract-plugin
export default {"driver_active":"driver-cell_driver_active__HQQ7l","driver_inactive":"driver-cell_driver_inactive__3CDCH"};